import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import {
  incomeSourceOptions,
  paymentStatusOption,
} from "../../../components/Data/DropDownData";
import {
  CalendarIcon,
  CurrencyDollarIcon,
  UserIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import dayjs from "dayjs";

const IncomeAddChild = () => {
  let navigate = useNavigate();
  const inputWidth = "230px";
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      boxShadow: "none", // This line disables the blue border
    }),
  };

  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [financial_year] = useState({
    value: user?.current_financial_year,
    label: user?.current_financial_year,
  });
  const [churchMembers, setChurchMembers] = useState([]);
  const [categoryList, setCategoryList] = useState();
  const [churchList, setChurchList] = useState();
  const [useOtherNonMember, setUseOtherNonMember] = useState(false);
  const [formData, setFormData] = useState({
    category_id: null,
    income_title: null,
    description: null,
    member_id: null,
    date: new Date().toISOString().split("T")[0],
    amount: null,
    status: null,
    income_source: null,
    other_non_member: null,
  });

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/category/income/${user?.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then((response) => {
          const oldData = response.data.Categorys;
          const updatedData = oldData.map((data) => ({
            value: data?._id,
            label: data?.category_name,
          }));
          setCategoryList(updatedData);
        })
        .catch((err) => {
          console.log("error api call ", err.response.data.message);
        });
    };
    getDataFromServer();
  }, []);

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/church/${user?.church_id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then((response) => {
        const members = response?.data?.users;
        setChurchMembers(
          members.map((member) => ({
            value: member._id,
            label: member.first_name + " " + member.last_name,
          }))
        );
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error);
        errorLogApi(error, "ChurchMemberList", "/income");
      });
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleAddIncome = (e) => {
    e.preventDefault();

    if (!formData?.income_source)
      return toast.error("Please select an income source");

    if (!formData?.status) return toast.error("Please select payment status");

    if (!formData?.amount) return toast.error("Please select payment amount");

    let userToken = localStorage.getItem("token");

    const finData = { ...formData, financial_year: financial_year?.label };

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/income/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: finData,
    };

    axios(config)
      .then((response) => {
        toast.success("Receipt Created Successfully.");
        navigate("/income");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "IncomeAddChild", "/income/add");
      });
  };

  const handleCheckboxChange = () => {
    setUseOtherNonMember(!useOtherNonMember);
    setFormData({
      ...formData,
      member_id: null,
      other_non_member: "",
    });
  };

  return (
    <div className="flex justify-center w-full min-h-screen bg-gray-50">
      <div className="w-full max-w-2xl p-8">
        <form
          onSubmit={(e) => handleAddIncome(e)}
          autoComplete="off"
          className="p-6 bg-white rounded-lg shadow-md"
        >
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-800">Add Receipt</h2>
            <div className="space-x-2">
              <button
                className="px-4 py-2 text-gray-600 transition duration-300 ease-in-out bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white transition duration-300 ease-in-out bg-blue-600 rounded-md hover:bg-blue-700"
                type="submit"
              >
                Create
              </button>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Category
              </label>
              <Select
                name="category_id"
                onChange={(selected) =>
                  setFormData({ ...formData, category_id: selected.value })
                }
                options={categoryList}
                placeholder={placeHolderText("Select Category")}
                className="w-full"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#D1D5DB",
                    borderRadius: "0.375rem",
                    "&:hover": { borderColor: "#9CA3AF" },
                  }),
                }}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Income Title
              </label>
              <input
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                name="income_title"
                type="text"
                required
                placeholder="Enter Income Title"
                onChange={handleChange}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Date
              </label>
              <div className="relative">
                <DatePicker
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  name="date"
                  value={formData.date ? dayjs(formData.date) : null}
                  onChange={(date, dateString) =>
                    setFormData({ ...formData, date: dateString })
                  }
                  format="MM-DD-YYYY"
                  showToday={true}
                />
                <CalendarIcon className="absolute w-5 h-5 text-gray-400 transform -translate-y-1/2 right-3 top-1/2" />
              </div>
            </div>

            <div>
              <div className="flex items-center mb-2">
                <input
                  type="checkbox"
                  checked={useOtherNonMember}
                  onChange={handleCheckboxChange}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label className="ml-2 text-sm text-gray-700">
                  Other Non Member
                </label>
              </div>
              {!useOtherNonMember ? (
                <Select
                  name="member_id"
                  onChange={(selected) =>
                    setFormData({
                      ...formData,
                      member_id: selected?.value,
                      other_non_member: null,
                    })
                  }
                  options={churchMembers}
                  placeholder={placeHolderText("Select Member")}
                  className="w-full"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: "#D1D5DB",
                      borderRadius: "0.375rem",
                      "&:hover": { borderColor: "#9CA3AF" },
                    }),
                  }}
                  isClearable
                />
              ) : (
                <div className="relative">
                  <input
                    className="w-full p-3 pl-10 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    name="other_non_member"
                    type="text"
                    required
                    placeholder="Enter Non Member"
                    onChange={handleChange}
                  />
                  <UserIcon className="absolute w-5 h-5 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
                </div>
              )}
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Amount
              </label>
              <div className="relative">
                <input
                  className="w-full p-3 pl-10 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  name="amount"
                  type="number"
                  required
                  placeholder="Enter Amount"
                  onChange={handleChange}
                />
                <CurrencyDollarIcon className="absolute w-5 h-5 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
              </div>
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Income Source
              </label>
              <Select
                name="income_source"
                onChange={(selected) =>
                  setFormData({ ...formData, income_source: selected.label })
                }
                options={incomeSourceOptions}
                placeholder={placeHolderText("Select Source")}
                className="w-full"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#D1D5DB",
                    borderRadius: "0.375rem",
                    "&:hover": { borderColor: "#9CA3AF" },
                  }),
                }}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Payment Status
              </label>
              <Select
                name="status"
                onChange={(selected) =>
                  setFormData({ ...formData, status: selected.value })
                }
                options={paymentStatusOption}
                placeholder={placeHolderText("Select Status")}
                className="w-full"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#D1D5DB",
                    borderRadius: "0.375rem",
                    "&:hover": { borderColor: "#9CA3AF" },
                  }),
                }}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Description
              </label>
              <div className="relative">
                <textarea
                  className="w-full p-3 pl-10 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  name="description"
                  rows={3}
                  placeholder="Income Description"
                  onChange={handleChange}
                />
                <DocumentTextIcon className="absolute w-5 h-5 text-gray-400 left-3 top-3" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IncomeAddChild;
